import { LoadingOutlined } from "@ant-design/icons";
import { Button, Row } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchChatHistory,
  updateBid,
  updateProposal,
} from "../../../../../../redux/actions";
import "./bidAccepted.css";

const BidAcceptedCard = (props) => {
  const dispatch = useDispatch();
  const bidStatus = useSelector((state) => state.messagesReducer.bidStatus);
  const loading = useSelector((state) => state.updateProposalReducers.loading);
  const bidLoading = useSelector((state) => state.updateBidReducers.loading);
  const [load, setLoad] = useState(false);
  const [reason, setReason] = useState([]);
  const [declinedReason, setDeclinedReason] = useState("");
  const [reasonId, setReasonId] = useState([]);
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));

  const declineReasons = [
    {
      id: 1,
      Reason: "Accepted another candidate",
    },
    {
      id: 2,
      Reason: "Not interested in the candidate",
    },
    {
      id: 3,
      Reason: "Not interested in this Gig",
    },
    {
      id: 4,
      Reason: "Asking payrate is too high",
    },
  ];

  const declineReasonsBid = [
    {
      id: 5,
      Reason: "Skills not a match",
    },
    {
      id: 2,
      Reason: "On Assignment",
    },
    {
      id: 3,
      Reason: "Not interested in the location",
    },
    {
      id: 4,
      Reason: "Estimated pay rate is too low",
    },
  ];

  const submitProfile = () => {
    setLoad(true);
    props?.source == 2
      ? dispatch(
          updateProposal({
            id: props?.bid_id,
            status: "Profile Submitted",
            loading: "Submitted",
          })
        )
      : dispatch(
          updateBid({
            id: props?.bid_id,
            BidStatusName: "Profile Submitted",
            SkillListingId: props?.SkillListing_id,
            loading: "Submitted",
          })
        );
    // fetchChat(props.data.ConversationId);
  };

  useEffect(() => {
    let test;
    let test_declined;
    let id;
    // console.log("props in accepted bid", props?.status);
    // props?.data?.SenderUser?.AccountId === userProfile?.AccountId
    //   ?
    id = props?.data?.BidCard
      ? props?.data?.BidCard?.DeclineReasonId
      : props?.data?.ProposalCard?.DeclineReasonId;

    setReasonId(id);
    // : props?.data?.OfferCard?.DeclineReasonId;
    if (
      props?.data?.SenderUser?.AccountId === userProfile?.AccountId &&
      id != 10
    ) {
      test = declineReasons?.filter((d) => d?.id == id);
    }
    // else if(props?.data?.SenderUser?.AccountId !== userProfile?.AccountId) {
    if (
      props?.status == "Declined Bid" &&
      props?.data?.SenderUser?.AccountId !== userProfile?.AccountId
    ) {
      test = declineReasonsBid?.filter((d) => d?.id == id);
    }
    // }
    else if (
      props?.status == "Declined Bid" &&
      props?.data?.SenderUser?.AccountId === userProfile?.AccountId &&
      id == 10
    ) {
      test_declined =
        props?.data?.BidCard != null
          ? props?.data?.BidCard?.DeclineReason
          : props?.data?.ProposalCard?.DeclineReason;
    }
    setReason(test);
    setDeclinedReason(test_declined);
  }, [props?.data]);
  // function fetchChat(params) {
  //   setTimeout(() => {
  //     dispatch(fetchChatHistory(params));
  //   }, 800);
  // }

  return (
    <div>
      {props.status == "Accepted Bid" && (
        <>
          <div>
            <strong>Bid Accepted </strong> <br />
            {userProfile?.Professions?.ProfessionCode === "HC"
              ? (props.source === 1
                ? "Congrats! The candidate accepted your bid. Submit the candidate’s profile to your facility to authorize an interview."
                : "Congrats! You accepted the candidate’s bid. Submit the candidate’s profile to your facility to authorize an interview."
              )
              : (props.source === 1
              ? "Congrats! The candidate accepted your bid. & the CTA."
              : "Congrats, you accepted the candidate’s bid. & the CTA.")}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "2%",
            }}
          >
            <Button
              className="bidAcceptedBtn"
              onClick={submitProfile}
              //disable
              disabled={
                bidStatus.includes("Profile Submitted") ||
                bidStatus.includes("Retracted Bid")
              }
              style={{
                background: bidStatus.includes("Profile Submitted") && "gray",
                color: bidStatus.includes("Profile Submitted") && "#fff",
              }}
            >
              {loading == "Submitted" || bidLoading == "Submitted" ? (
                <LoadingOutlined />
              ) : userProfile?.Professions?.ProfessionCode == "HC" ? (
                "Submit profile to the facility"
              ) : (
                "Move to Schedule Interview"
              )}
            </Button>
          </div>
        </>
      )}
      {bidStatus.includes("Accepted Bid") && props.status == "Declined Bid" ? (
        <div>
          <div>
            <strong>
              {props?.data?.SenderUser?.AccountId === userProfile?.AccountId
                ? "Declined Offer!"
                : "Declined!"}
            </strong>{" "}
            <br />
            {props?.data?.SenderUser?.AccountId === userProfile?.AccountId
              ? "You’ve declined an offer to the candidate"
              : "Declined! Candidate has declined your offer"}
          </div>
          <div
            style={{
              background: "#fff",
              padding: "2.5%",
              marginTop: "2%",
              borderRadius: "5px",
            }}
          >
            <strong>Reason</strong> <br />
            {props?.data?.OfferCard?.DeclineReason
              ? props?.data?.OfferCard?.DeclineReason
              : reason?.length > 0 && reason[0]?.Reason}
            {declinedReason}
          </div>
        </div>
      ) : (
        props.status == "Declined Bid" && (
          <div>
            <div>
              <div>
                <strong>Declined Bid</strong> <br />
                {props?.data?.SenderUser?.AccountId === userProfile?.AccountId
                  ? "You declined a bid received from candidate"
                  : "Unfortunately, the candidate has declined your bid."}
              </div>
              <div
                style={{
                  background: "#fff",
                  padding: "2.5%",
                  marginTop: "2%",
                  borderRadius: "5px",
                }}
              >
                <strong>Reason</strong> <br />
                {reasonId == 10
                  ? declinedReason
                  : reason?.length > 0 && reason[0]?.Reason}
              </div>
            </div>
          </div>
        )
      )}
      {}

      {props.status == "Offer Declined" && (
        <div>
          <div>
            <strong>
              {props?.data?.SenderUser?.AccountId === userProfile?.AccountId
                ? "Declined Offer!"
                : "Declined!"}
            </strong>{" "}
            <br />
            {props?.data?.SenderUser?.AccountId === userProfile?.AccountId
              ? "You’ve declined an offer to the candidate"
              : "Declined! Candidate has declined your offer"}
          </div>
          <div
            style={{
              background: "#fff",
              padding: "2.5%",
              marginTop: "2%",
              borderRadius: "5px",
            }}
          >
            <strong>Reason</strong> <br />
            {props?.data?.OfferCard?.DeclineReason
              ? props?.data?.OfferCard?.DeclineReason
              : reason.length > 0 && reason[0].Reason}
            {/* {declinedReason} */}
          </div>
        </div>
      )}

      {props.status == "Terminated" && (
        <div>
          <div>
            {/* <strong>Sorry!</strong> <br /> */}
            {props.MessageText}
          </div>
          <div
            style={{
              background: "#fff",
              padding: "2.5%",
              marginTop: "2%",
              borderRadius: "5px",
            }}
          >
            <Row>
              <div>Start date</div>
              <div>mm/dd/yyyy</div>
            </Row>
            <Row>
              <div>End date</div>
              <div>mm/dd/yyyy</div>
            </Row>
            <Row>
              <div>Estimated pay rate/package</div>
              <div>USD 73/HR</div>
            </Row>
            <Row>
              <div>Contract duration</div>
              <div>13 months</div>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};
export default BidAcceptedCard;
